import React, { SyntheticEvent } from 'react'

import Grid from '../../../../components/Grid'
import { certificates as _certs, contactItem as _contact, shippingTypes as _shippings } from './data'
import ImageLink from '../ImageLink'

import ELocale from '../../../../types/locales'
import { formatPhoneNumber, hasMinWidthOf, itemExistsInLocale } from '../../utils'
import { TItem } from '../../types'
import { TTickerItem } from '../../../../types/tickers'
import Icon, { EIconId } from '../../../../components/icons'

const CheckoutArea: React.FC<{
  locale: ELocale
  tickers: TTickerItem[]
  certificates?: TItem[]
  shippingTypes?: TItem[]
  contactItem?: TItem
}> = (props) => {
  const { locale, tickers, certificates = _certs, shippingTypes = _shippings, contactItem = _contact } = props
  const handleClick = (e: SyntheticEvent) => {
    // ignore clicks on tablet and above
    if (hasMinWidthOf('ms')) {
      e.preventDefault()
    }
  }

  const returnPolicy = tickers[1]
  const returnPolicyText =
    returnPolicy !== undefined
      ? `${returnPolicy?.text}${returnPolicy?.footNoteIndicator}`
      : '30 Tage kostenfreie Rücksendung'

  return (
    <Grid.Container>
      <Grid.Row hasGutter={true}>
        <Grid.Col width={12} sm={6} lg={3}>
          <p className="font-bold mb-16 mt-48">10,5 Millionen Kunden</p>
          <ul className="flex">
            {certificates.map(
              (certificate, index) =>
                itemExistsInLocale(certificate, locale) && (
                  <ImageLink key={certificate.label} type={'medium'} index={index} item={certificate} as="li" />
                ),
            )}
          </ul>
        </Grid.Col>
        <Grid.Col width={12} sm={6} lg={3}>
          <p className="font-bold mb-16 mt-32 sm:mt-48">Schnelle Lieferung</p>
          <ul className="flex">
            {shippingTypes.map(
              (shippingType, index) =>
                itemExistsInLocale(shippingType, locale) && (
                  <ImageLink key={shippingType.label} type={'medium'} index={index} item={shippingType} as="li" />
                ),
            )}
          </ul>
        </Grid.Col>
        <Grid.Col width={12} sm={6} lg={3}>
          <p className="font-bold mb-16 mt-32 md:mt-48">Rücknahme ohne Wenn und Aber</p>
          <div className="flex items-center">
            <Icon id={EIconId.EXCHANGE} className="w-40 flex-none mr-8" />
            {returnPolicyText}
          </div>
        </Grid.Col>
        <Grid.Col width={12} sm={6} lg={3}>
          <p className="font-bold mb-16 mt-32 lg:mt-48">Benötigen Sie Hilfe?</p>
          <a
            href={`tel:+49-${formatPhoneNumber(contactItem.url as string)}`}
            className="flex items-center sm:cursor-default"
            onClick={handleClick}
          >
            {contactItem.icon}
            {contactItem.url}
          </a>
        </Grid.Col>
      </Grid.Row>
    </Grid.Container>
  )
}

export { CheckoutArea as default }
